export type NoopType = () => void;

const noop = (): void => {
	/* empty */
};

export default noop;
